
export default function AdditionalCss({ payload }: any) {
  return <style>{payload && payload.replaceAll('/>','')}</style>;
}
